export default __webpack_public_path__ + "static/media/rakhi7.8b9d89e8.jpeg";